'use client'

import { redirect, usePathname, useSearchParams } from 'next/navigation'

import { useSession } from 'next-auth/react'

import type { Locale } from '@configs/i18n'

import themeConfig from '@configs/themeConfig'
import { getLocalizedUrl } from '@/utils/i18n'

const AuthRedirect = ({ lang }: { lang: Locale }) => {
  const pathname = usePathname()
  const { data: session, status } = useSession()
  const searchParams = useSearchParams()

  const preserveParams = () => {
    const params = new URLSearchParams(searchParams)

    return params.toString() ? `?${params.toString()}` : ''
  }

  const redirectUrl = `/${lang}/login?redirectTo=${pathname}${preserveParams()}`
  const login = `/${lang}/login`
  const homePage = getLocalizedUrl(themeConfig.homePageUrl, lang)

  console.log(`AuthRedirect: path=${pathname}, login=${login}, homepage= ${homePage}, redirect= ${redirectUrl}`)
  console.log(`AuthRedirect: session=${JSON.stringify(session)}, status=${status}`)

  if (status === 'authenticated') {
    console.log('User is authenticated, no redirect needed')
    return null
  }

  if (status === 'unauthenticated') {
    console.log('User is not authenticated, redirecting to login')

    return redirect(pathname === login ? login : redirectUrl)
  }

  return null
}

export default AuthRedirect
